module.exports = __webpack_public_path__ + "media/images/xpass/class-featured-04109e26f2528b2f1295f9221a900f8c.svg";